var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcGeneralInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.0087 34.7042C54.0087 23.6585 38.3412 11.9997 23.2819 11.9997C8.2225 11.9997 2.05151 22.5149 2.00011 34.7042C1.95101 46.3471 18.3897 32.6385 28.6017 37.9995C42.5692 45.3319 54.0087 45.7499 54.0087 34.7042Z",
    fill: "#DCF5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 17.3333V24.3333M28 31.3333V31.3567M42 8C43.8565 8 45.637 8.7375 46.9498 10.0503C48.2625 11.363 49 13.1435 49 15V33.6667C49 35.5232 48.2625 37.3037 46.9498 38.6164C45.637 39.9292 43.8565 40.6667 42 40.6667H30.3333L18.6667 47.6667V40.6667H14C12.1435 40.6667 10.363 39.9292 9.05025 38.6164C7.7375 37.3037 7 35.5232 7 33.6667V15C7 13.1435 7.7375 11.363 9.05025 10.0503C10.363 8.7375 12.1435 8 14 8H42Z",
    stroke: "#A2CD3A",
    strokeWidth: 4.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 17.335V24.335M28 31.335V31.3583",
    stroke: "#29ABE2",
    strokeWidth: 4.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGeneralInfo);
export default __webpack_public_path__ + "static/media/ic-general-info.3de5622dac4cdb23cf06d39278d5b43a.svg";
export { ForwardRef as ReactComponent };